import { render, staticRenderFns } from "./tableBroker.vue?vue&type=template&id=7c8089d6&"
import script from "./tableBroker.vue?vue&type=script&lang=js&"
export * from "./tableBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports